
import React from 'react';

const Information = (type, info) => {
  if (info) {
    return (
      <div className="form-group">
        <label>{type}</label>
        <div className="form-control">{info}</div>
      </div>
    );
  }
  return ;
};
export default Information;



// WEBPACK FOOTER //
// ./src/components/MyServices/InformationItem.js